import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { TourSaleFormType } from '../components/form-type';

export default function useRecalculate() {
  const { control, setValue } = useFormContext<TourSaleFormType>();
  const [tourSales, otherCost, discount] = useWatch({
    control,
    name: ['tourSales', 'otherCost', 'discount'],
  });

  const data = React.useMemo(() => {
    const subtotal = tourSales.reduce((prev, hp) => {
      const subtotalGuest = hp.tourSaleGuests.reduce((prev, tsg) => {
        return prev + (tsg.price || 0);
      }, 0);

      const subtotalAddOns = hp.tourSaleAddOns.reduce(
        (prev, tsao) => prev + (tsao.price || 0),
        0,
      );
      return prev + subtotalGuest + subtotalAddOns;
    }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
    };
  }, [discount, otherCost, setValue, tourSales]);

  return data;
}
